export function placeHasValidBillingProfile(place) {
  return !!(place?.BillingProfile || place?.DefaultBillingProfile);
}
export function selectProperBillingProfileFromPlace(place) {
  const {
    DefaultBillingProfile,
    BillingProfile,
    IsUsingDefaultBillingProfile,
  } = place;
  if (!placeHasValidBillingProfile(place)) return null;
  if (IsUsingDefaultBillingProfile)
    return DefaultBillingProfile || BillingProfile;
  return BillingProfile || DefaultBillingProfile;
}
